import React from 'react';
import { useFormContext } from 'react-hook-form';
import useWindowSize from '../../hooks/useWindowSize';

interface Props {
    todayDate: string;
}

const DateRangeFilter: React.FC<Props> = ({ todayDate }) => {
    const { register, formState: { errors } } = useFormContext();
    const { width } = useWindowSize();

    return (
        <>
            <label
                className="w-full md:w-[25%] flex flex-col relative min-h-[70px]"
                style={{ minHeight: width >= 901 ? '90px' : undefined }}
            >
                <span className="font-semibold">Data Inicial</span>
                <input
                    type="date"
                    className="border border-gray-400 h-11 rounded-full"
                    max={todayDate}
                    {...register('start_date')}
                />
                {typeof errors?.start_date?.message === 'string' && (
                    <p className="text-red-400 absolute top-3/4">
                        {errors.start_date.message}
                    </p>
                )}

            </label>

            <label
                className="w-full md:w-[25%] flex flex-col relative min-h-[70px]"
                style={{ minHeight: width >= 901 ? '90px' : undefined }}
            >
                <span className="font-semibold">Data Final</span>
                <input
                    type="date"
                    className="border border-gray-400 h-11 rounded-full"
                    max={todayDate}
                    {...register('end_date')}
                />
                {typeof errors?.end_date?.message === 'string' && (
                    <p className="text-red-400 absolute top-3/4">
                        {errors.end_date.message}
                    </p>
                )}

            </label>
        </>
    );
};

export default DateRangeFilter;
